export enum SideNavId {
  TEXT_NOTE = "textNote",
  SCREENSHOT_RENDERER = "screenshot-renderer",
  PDF_RENDERER = "pdf-renderer",
  CASE_SUMMARY = "case-summary",
  /** Timeline of calling history logs (same data as submission side panel History tab). */
  CALLING_SUMMARY = "calling-summary",
  AUTH = "auth",
  SIGNED_COPY = "signed-copy",
  SFTP_SUMMARY_RESPONSE_STATUS = "sftp-summary-response-status",
  SFTP_SUMMARY_TEXT_NOTES = "sftp-summary-text-notes",
  TASK_HISTORY = "task-history",
  DOCUMENT = "document",
  DENIAL_LETTER = "denial-letter",
}
